import { breakpointSizes, getBreakpointDown } from '@paywithextend/components'
import { base_colorRaisedSurface } from 'ext-ui/style/colors'
import { css } from 'styled-components'

export default css`
  background-color: ${base_colorRaisedSurface};
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  gap: 60px;

  ${getBreakpointDown(breakpointSizes.MD)(css`
    padding: 0px;
  `)}

  .unauthedBoxContainer {
    display: flex;
    flex-direction: column;
    padding: 80px;

    ${getBreakpointDown(breakpointSizes.MD)(css`
      width: 100%;
      align-items: center;
      padding: 40px 10px;
    `)}
  }

  .signupForm {
    min-width: 400px;
    ${getBreakpointDown(breakpointSizes.XSM)(css`
      min-width: auto;
    `)}
  }
`

export const boxStyling = css`
  background-color: unset;
  box-shadow: none;
  padding-top: 20px;
  padding-bottom: 20px;
`
